<div>
    <div class="pricing-container" id="pdfTable" #pdfTable>
        <app-price-selection *ngIf="formDetails" [formDetails]="formDetails" [selectedValues]="selectedValues"
            (onSelectFilter)="searchSalesData($event)" (onResetFilter)="resetFilter($event)"></app-price-selection>
        <div class="grid">

            <app-price-bridge *ngIf="chartLoaded" [totalPricePercVal] = "totalPricePercVal" [data]="data" (chartClick)="chartClick($event)"></app-price-bridge>

            <div>
                <div class="high-value-title">
                    <span class="head">TOTAL PRICE IMPACT BY PRICE SPEC</span>
                </div>
                <div class="table-container">

                    <table mat-table [dataSource]="search ? filteredData : dataSource" class="mat-elevation-z8"
                        style="width: 100%">
                        <!--- Note that these columns can be defined in any order.
                The actual rendered columns are set as a property on the row definition" -->

                        <!-- Position Column -->
                        <ng-container matColumnDef="name">
                            <th mat-header-cell *matHeaderCellDef class="border-left">
                                {{ tableCloumnFirst | uppercase }}
                            </th>
                            <td mat-cell *matCellDef="let element">
                                {{ element.name }}
                            </td>
                            <td mat-footer-cell *matFooterCellDef>TOTAL</td>
                        </ng-container>

                        <!-- Name Column -->
                        <ng-container matColumnDef="price">
                            <th mat-header-cell *matHeaderCellDef class="border-right">
                                {{ tableCloumnSecond | uppercase }}
                            </th>
                            <td mat-cell *matCellDef="let element">
                                {{ element.price | dollar }}
                            </td>
                            <td mat-footer-cell *matFooterCellDef>{{ total | dollar }}</td>
                        </ng-container>
                        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns"
                            [ngClass]="{ highlight: selectedRowIndex == row.name }" (click)="getOverallPurePrice(row)"
                            class="table-body"></tr>
                        <tr mat-footer-row *matFooterRowDef="displayedColumns; sticky: true"></tr>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>